import { Directive, OnInit, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { FormatService } from '../services/format.service';

@Directive({ selector: '[PhoneFormatter]' })
export class PhoneFormatterDirective implements OnInit {
	private el: HTMLInputElement;

	constructor(private elementRef: ElementRef, private formatSvc: FormatService, private control: NgControl) {
		this.el = this.elementRef.nativeElement;
	}

	ngOnInit() {}

	@HostListener('input', ['$event.target.value'])
	input(value) {
		this.el.value = this.formatSvc.formatPhone(value);
		this.control.control.patchValue(this.el.value);
	}
}
